import { Check } from '@phosphor-icons/react';

import { cn } from '@/lib/utils';

import type { FilterChip } from './types';

interface FilterChipRowProps {
  available: FilterChip[];
  active: FilterChip[];
  onChange: (next: FilterChip[]) => void;
  allLabel: string;
}

export function FilterChipRow({ available, active, onChange, allLabel }: FilterChipRowProps) {
  const activeIds = new Set(active.map((c) => c.id));

  const toggle = (chip: FilterChip) => {
    if (activeIds.has(chip.id)) {
      onChange(active.filter((c) => c.id !== chip.id));
    } else {
      onChange([...active, chip]);
    }
  };

  return (
    <div className="flex flex-wrap items-center gap-2" role="group" aria-label="Filters">
      <button
        type="button"
        onClick={() => onChange([])}
        aria-pressed={active.length === 0}
        className={cn(
          'inline-flex items-center gap-1.5 rounded-full px-3.5 h-9 text-sm font-medium',
          'transition-colors duration-150 ease-biz-out biz-motion-safe biz-focus-ring',
          active.length === 0
            ? 'bg-biz-primary text-biz-primary-foreground'
            : 'border border-biz-border bg-biz-surface-elevated text-biz-foreground-muted hover:text-biz-foreground hover:bg-biz-muted',
        )}
      >
        {active.length === 0 && <Check size={14} weight="regular" />}
        {allLabel}
      </button>
      {available.map((chip) => {
        const isActive = activeIds.has(chip.id);
        return (
          <button
            key={chip.id}
            type="button"
            onClick={() => toggle(chip)}
            aria-pressed={isActive}
            className={cn(
              'inline-flex items-center gap-1.5 rounded-full px-3.5 h-9 text-sm font-medium',
              'transition-colors duration-150 ease-biz-out biz-motion-safe biz-focus-ring',
              isActive
                ? 'bg-biz-primary text-biz-primary-foreground'
                : 'border border-biz-border bg-biz-surface-elevated text-biz-foreground-muted hover:text-biz-foreground hover:bg-biz-muted',
            )}
          >
            {isActive && <Check size={14} weight="regular" />}
            {chip.label}
          </button>
        );
      })}
    </div>
  );
}
